var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brands-layout"},[_c('div',{staticClass:"filter-list-layout"},[_c('div',{staticClass:"filter"},[_c('SearchItems',{attrs:{"items":_vm.searchItems},on:{"doSearch":_vm.doSearch}})],1),_c('div',{staticClass:"list"},[_vm._v("list")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }